import { ACTION } from './constants';
import request from '../../../../utils/request';
import { requestConfig } from '../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../actions';

export function iapPageData(serverData,informationId) {
    if(serverData.url){
        let urlArray=serverData.url.split('/');
        informationId = urlArray[urlArray.length-1];
    }

    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.iapPageData(informationId))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.IAP_DATA , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Information data: " + error)
            });
    }
}
export function iapCallUs(formdata) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.iapCallUs(formdata))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.IAP_CALL_US, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with IAP Call Us Api: " + error)
            });
    }
}
export function getEduCoursesContent(langdata) {
    let lang;
    if (!__CLIENT__) {
      lang = getLang();
    } else {
      lang = langdata;
    }
    return (dispatch) => {
      return request(requestConfig.getEducationCourses(lang))
        .then((json) => {
          json &&
            dispatch({ type: ACTION.GET_EDU_COURSES_CONTENT, data: json.data });
          return json;
        })
        .catch((error) => {
          console.log(`Got Error with Child education courses Content: ${error}`);
        });
    };
  }
  export function iapgetFaqs(formData, typeData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.iapgetFaqs(formData, typeData))
            .then((json) => {
                json && dispatch({ type: ACTION.IAP_FAQS , data: json.data });
                dispatch(hideMainLoader());
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error IAP faqs Data: " + error)
            });
    }
  }
  